import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchMaterials } from "#modules/materials/infra/fetchMaterials.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const materialsQuery = () => ({
  queryKey: queryKeys.materials.all,
  queryFn: () => fetchMaterials(),
  staleTime: STALE_TIME,
});
